import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    order: [],
}

export const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        addOrder: (state, action) => {
            state.order.push(action.payload)
        },
        deleteOrder: (state, action) => {
            state.order.filter(user => action.payload.id != user.id)
        },
        updateOrder: (state, action) => {
            state.order.map(user => {
                if (user.id == action.payload.id) return action.payload
                return user
            })
        },
    },
})

// Action creators are generated for each case reducer function
export const { addOrder, deleteOrder, updateOrder } = orderSlice.actions

export default orderSlice.reducer